module.exports = __webpack_public_path__ + "img/qwen-batch-lamp-03.09ce579d.webp";